"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "retailers", {
    enumerable: true,
    get: ()=>retailers
});
const _graphqlRequest = require("graphql-request");
const _retailerFragment = require("../fragments/retailer-fragment");
const retailers = (0, _graphqlRequest.gql)`
    query retailersByLocation(
        $latitude: Float!,
        $longitude: Float!,
        $maxDistance: Float!,
        $unit: DistanceUnit!
    ) {
        retailersNearLocation(
            location: {
                coordinates: {
                    latitude: $latitude
                    longitude: $longitude
                }
                maxDistance: $maxDistance
                unit: $unit
            }
        ) {
            retailer {
                ...retailerFragment
            },
            locationDetail {
                distance
                unit
                maxDistance
                validForDelivery
            }
        }
    }
    ${_retailerFragment.RETAILER_FRAGMENT}
`;
